'use client';

import React, { useState } from 'react';
import { AdminHeader } from '../components/AdminHeader';
import { AdminSidebar } from '../components/AdminSidebar';
import type { AdminSectionId } from '../../constants/sections';

export interface AdminLayoutProps {
  currentSection: AdminSectionId;
  onSectionChange: (section: AdminSectionId) => void;
  onLogout?: () => void | Promise<void>;
  isLoggingOut?: boolean;
  adminDisplayName?: string;
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({
  currentSection,
  onSectionChange,
  onLogout,
  isLoggingOut = false,
  adminDisplayName,
  children,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen font-app text-app-body text-text-body bg-[#f0f4f8] antialiased">
      <AdminHeader
        adminDisplayName={adminDisplayName}
        onLogout={onLogout}
        isLoggingOut={isLoggingOut}
        onMenuClick={() => setSidebarOpen(true)}
      />

      <AdminSidebar
        currentSection={currentSection}
        onSectionChange={onSectionChange}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <main className="pt-[calc(3.5rem+env(safe-area-inset-top,0px))] lg:pl-64 min-h-screen flex flex-col">
        <div className="flex-1 overflow-auto px-4 pt-4 sm:px-6 sm:pt-6 lg:px-8 lg:pt-8 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] sm:pb-[calc(1.5rem+env(safe-area-inset-bottom,0px))] lg:pb-[calc(2rem+env(safe-area-inset-bottom,0px))]">
          {children}
        </div>
      </main>
    </div>
  );
};
